import styled from "@emotion/styled";
import { Box, Button } from "Components";
import { theme } from "Application";

export const TableBox = styled(Box)`
    width: 100%;
    padding-top: 30px;
    max-width: calc(100vw - 60px);
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px dashed ${theme.palette.tableHeader.main};
    @media only screen and (max-width: 1024px) {
        max-width: calc(100vw - 40px);
    }
`;

export const SwitchBox = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    .switch {
        position: relative;
        display: inline-block;
        width: 50px;
        height: 28px;
    }
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fcd21d;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }
    .slider:before {
        position: absolute;
        content: "";
        height: 22px;
        width: 22px;
        left: 4px;
        bottom: 3px;
        background-color: #000000;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }
    input:checked + .slider {
        background-color: #fcd21d;
    }
    input:focus + .slider {
        box-shadow: none;
    }
    input:checked + .slider:before {
        -webkit-transform: translateX(20px);
        -ms-transform: translateX(20px);
        transform: translateX(20px);
    }
    .slider.round {
        border-radius: 50px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
`;

export const SwitchTitleBox = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px 30px;
    @media only screen and (max-width: 767px) {
        flex-wrap: wrap;
    }
`;

export const ResetRotaButton = styled(Button)`
    height: 40px;
    min-width: 130px;
`;

export const AddAbsenceButton = styled(Button)`
    height: 40px;
    min-width: 220px;
`;
